import { css } from 'lit';

export const planeUpdatePromptStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: var(--z-overlay);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: var(--space-2) var(--space-4);
    padding: var(--space-3) calc(var(--space-5) + var(--safe-right)) calc(var(--space-3) + var(--safe-bottom))
      calc(var(--space-5) + var(--safe-left));
    background: var(--masthead);
    color: var(--masthead-text);
    border-top: var(--edge-width) solid var(--accent);
    font-size: var(--font-size-md);
  }
`;
